var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"banner"}},[_c('div',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":"/"}},[_c('p',[_vm._v(_vm._s(_vm.$t('base.seoBanner')))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }